module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discuss"
  }, [_c('div', {
    staticClass: "discuss-detail"
  }, [(_vm.limitImg == 9) ? _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    directives: [{
      name: "lazy-container",
      rawName: "v-lazy-container",
      value: ({
        selector: 'img'
      }),
      expression: "{ selector: 'img' }"
    }],
    staticStyle: {
      "height": "0.5rem"
    }
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "data-src": _vm.faceUrl,
      "alt": "",
      "data-error": _vm.errorImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-right"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "nickName_createTime"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "0.1rem",
      "font-size": "0",
      "/*display": "flex",
      "align-items": "center"
    }
  }, [_c('p', {
    staticClass: "nickName",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "bottom"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.nickName && _vm.discussItem.nickName.slice(0, 15)))
    }
  }), _vm._v(" "), (_vm.discussItem.isTop == 1) ? _c('svg', {
    staticClass: "is-top-style",
    attrs: {
      "viewBox": "0 0 2048 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M512 30.117647C246.964706 30.117647 30.117647 246.964706 30.117647 512s216.847059 481.882353 481.882353 481.882353h1024c265.035294 0 481.882353-216.847059 481.882353-481.882353S1801.035294 30.117647 1536 30.117647H512z m0-30.117647h1024c283.105882 0 512 228.894118 512 512s-228.894118 512-512 512H512C228.894118 1024 0 795.105882 0 512S228.894118 0 512 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M352.376471 397.552941H632.470588l3.011765-42.164706h-237.929412V219.858824h524.047059v135.529411h-234.917647l-3.011765 42.164706h289.129412v39.152941h-292.141176c-3.011765 15.058824-6.023529 27.105882-9.035295 42.164706h210.82353v319.247059h105.411765v42.164706H340.329412v-42.164706h105.411764V478.870588h174.682353c3.011765-15.058824 6.023529-27.105882 9.035295-42.164706h-274.070589v-39.152941z m141.552941 400.564706h334.305882v-48.188235H493.929412v48.188235z m0-81.317647h334.305882v-45.176471H493.929412v45.176471z m0-78.305882h334.305882v-45.176471H493.929412v45.176471z m0-78.305883h334.305882v-45.17647H493.929412v45.17647z m382.494117-240.941176v-60.235294h-108.423529v60.235294h108.423529z m-156.611764 0v-60.235294h-114.447059v60.235294h114.447059z m-162.635294 0v-60.235294H451.764706v60.235294h105.411765z m783.058823-96.376471h364.42353v51.2h-159.62353c-3.011765 27.105882-6.023529 51.2-9.035294 75.294118h144.564706V692.705882h-51.2v-295.152941h-219.858824V692.705882h-51.2V349.364706h123.482353c3.011765-24.094118 6.023529-51.2 9.035294-75.294118h-153.6V222.870588z m240.941177 472.847059c51.2 39.152941 96.376471 81.317647 132.517647 120.470588l-36.141177 39.152941c-33.129412-39.152941-75.294118-81.317647-129.505882-126.494117l33.129412-33.129412z m-87.341177-256h51.2v129.505882c-3.011765 75.294118-21.082353 138.541176-57.223529 183.717647-36.141176 42.164706-93.364706 75.294118-174.682353 99.388236l-27.105883-45.176471c78.305882-21.082353 129.505882-51.2 162.635295-90.352941 30.117647-39.152941 45.176471-87.341176 45.17647-150.588235v-126.494118zM1165.552941 846.305882H1084.235294l-12.047059-48.188235c27.105882 0 51.2 3.011765 75.294118 3.011765 18.070588 0 27.105882-12.047059 27.105882-30.117647V274.070588h-111.435294V222.870588h252.988235v51.2h-87.341176V783.058824c0 42.164706-21.082353 63.247059-63.247059 63.247058z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "createTime"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    domProps: {
      "textContent": _vm._s(_vm.parseDateTime(_vm.discussItem.createTime))
    }
  }), _vm._v(" "), (_vm.ipSwitch == 1 && _vm.discussItem.ip) ? _c('span', {
    staticStyle: {
      "display": "inline-block"
    },
    domProps: {
      "textContent": _vm._s(!_vm.discussItem.ipAddress && 'IP：未知' || 'IP：' + _vm.discussItem.ipAddress)
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('commentOperation', {
    attrs: {
      "item": _vm.discussItem,
      "isDetail": _vm.limitImg
    },
    on: {
      "detailShowPopover": _vm.detailShowPopover
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3) ? _c('div', {
    staticClass: "user-info user-info-3"
  }, [_c('div', {
    directives: [{
      name: "lazy-container",
      rawName: "v-lazy-container",
      value: ({
        selector: 'img'
      }),
      expression: "{ selector: 'img' }"
    }],
    staticStyle: {
      "height": "0.5rem"
    }
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "data-src": _vm.faceUrl,
      "alt": "",
      "data-error": _vm.errorImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-right",
    staticStyle: {
      "height": "0.5rem"
    }
  }, [_c('p', {
    staticClass: "nickName",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.nickName && _vm.discussItem.nickName.slice(0, 15)))
    }
  }), _vm._v(" "), (_vm.discussItem.isTop == 1) ? _c('svg', {
    staticClass: "is-top-style",
    staticStyle: {
      "display": "block",
      "line-height": "normal",
      "height": "auto"
    },
    attrs: {
      "viewBox": "0 0 2048 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M512 30.117647C246.964706 30.117647 30.117647 246.964706 30.117647 512s216.847059 481.882353 481.882353 481.882353h1024c265.035294 0 481.882353-216.847059 481.882353-481.882353S1801.035294 30.117647 1536 30.117647H512z m0-30.117647h1024c283.105882 0 512 228.894118 512 512s-228.894118 512-512 512H512C228.894118 1024 0 795.105882 0 512S228.894118 0 512 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M352.376471 397.552941H632.470588l3.011765-42.164706h-237.929412V219.858824h524.047059v135.529411h-234.917647l-3.011765 42.164706h289.129412v39.152941h-292.141176c-3.011765 15.058824-6.023529 27.105882-9.035295 42.164706h210.82353v319.247059h105.411765v42.164706H340.329412v-42.164706h105.411764V478.870588h174.682353c3.011765-15.058824 6.023529-27.105882 9.035295-42.164706h-274.070589v-39.152941z m141.552941 400.564706h334.305882v-48.188235H493.929412v48.188235z m0-81.317647h334.305882v-45.176471H493.929412v45.176471z m0-78.305882h334.305882v-45.176471H493.929412v45.176471z m0-78.305883h334.305882v-45.17647H493.929412v45.17647z m382.494117-240.941176v-60.235294h-108.423529v60.235294h108.423529z m-156.611764 0v-60.235294h-114.447059v60.235294h114.447059z m-162.635294 0v-60.235294H451.764706v60.235294h105.411765z m783.058823-96.376471h364.42353v51.2h-159.62353c-3.011765 27.105882-6.023529 51.2-9.035294 75.294118h144.564706V692.705882h-51.2v-295.152941h-219.858824V692.705882h-51.2V349.364706h123.482353c3.011765-24.094118 6.023529-51.2 9.035294-75.294118h-153.6V222.870588z m240.941177 472.847059c51.2 39.152941 96.376471 81.317647 132.517647 120.470588l-36.141177 39.152941c-33.129412-39.152941-75.294118-81.317647-129.505882-126.494117l33.129412-33.129412z m-87.341177-256h51.2v129.505882c-3.011765 75.294118-21.082353 138.541176-57.223529 183.717647-36.141176 42.164706-93.364706 75.294118-174.682353 99.388236l-27.105883-45.176471c78.305882-21.082353 129.505882-51.2 162.635295-90.352941 30.117647-39.152941 45.176471-87.341176 45.17647-150.588235v-126.494118zM1165.552941 846.305882H1084.235294l-12.047059-48.188235c27.105882 0 51.2 3.011765 75.294118 3.011765 18.070588 0 27.105882-12.047059 27.105882-30.117647V274.070588h-111.435294V222.870588h252.988235v51.2h-87.341176V783.058824c0 42.164706-21.082353 63.247059-63.247059 63.247058z"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3) ? _c('div', {
    staticClass: "content list-content"
  }, [(_vm.discussItem.source == 1 && _vm.discussItem.aid > 0) ? _c('a', {
    style: ({
      '-webkit-line-clamp': (_vm.discussItem._picsLength > 0 ? 2 : 4)
    }),
    attrs: {
      "href": _vm.articleJumpUrl(25, _vm.discussItem.aid)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.content))
    }
  }) : _c('router-link', {
    style: ({
      '-webkit-line-clamp': (_vm.discussItem._picsLength > 0 ? 2 : 4)
    }),
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussItem.discussID,
          topicItem: _vm.discussItem
        }
      }
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.content))
    }
  })], 1) : _c('div', {
    staticClass: "content",
    style: ({
      '-webkit-line-clamp': (_vm.discussItem._picsLength > 2 ? 2 : 4)
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.discussItem.content))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discussItem._picsLength > 0),
      expression: "discussItem._picsLength>0"
    }],
    staticClass: "content content-images clearfix",
    class: {
      'more_two': _vm.discussItem._picsLength > 1
    }
  }, _vm._l((_vm.discussItem.attUrls && _vm.discussItem.attUrls.pics), function(item, index) {
    return (index < _vm.limitImg) ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.url),
        expression: "item.url"
      }],
      style: ({
        width: _vm.discussItem._picsWidth,
        height: _vm.discussItem._picsHeight
      }),
      attrs: {
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.detailShowSwiper(index)
        }
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discussItem._videosLength > 0),
      expression: "discussItem._videosLength>0"
    }],
    staticClass: "content content-video"
  }, [_c('video', {
    style: ({
      height: _vm.discussItem._videosHeight
    }),
    attrs: {
      "controls": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "x5-video-player-type": "h5-page",
      "src": _vm.discussItem.attUrls && _vm.discussItem.attUrls.videos && _vm.discussItem.attUrls.videos[0] && _vm.discussItem.attUrls.videos[0].url,
      "poster": _vm.discussItem.attUrls && _vm.discussItem.attUrls.videoPics && _vm.discussItem.attUrls.videoPics[0] && _vm.discussItem.attUrls.videoPics[0].url,
      "controlsList": (_vm.isAndroidApp && 'nofullscreen' || '')
    }
  })]), _vm._v(" "), (_vm.limitImg == 3 && _vm.discussItem.source == 1 && _vm.discussItem.aid > 0) ? _c('div', {
    staticClass: "members-contribute"
  }, [_c('a', {
    staticClass: "members-contribute-inner",
    attrs: {
      "href": _vm.articleJumpUrl(25, _vm.discussItem.aid)
    }
  }, [(_vm.discussItem.attUrls && _vm.discussItem.attUrls.pics && _vm.discussItem.attUrls.pics[0] && _vm.discussItem.attUrls.pics[0].url) ? _c('img', {
    attrs: {
      "src": _vm.discussItem.attUrls.pics[0].url,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.parseSpace(_vm.discussItem.title))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3) ? _c('div', {
    staticClass: "createTime-comment-operation"
  }, [_c('p', {
    staticClass: "createTime"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    domProps: {
      "textContent": _vm._s(_vm.parseDateTime(_vm.discussItem.createTime))
    }
  }), _vm._v(" "), (_vm.ipSwitch == 1 && _vm.discussItem.ip) ? _c('span', {
    staticStyle: {
      "display": "inline-block"
    },
    domProps: {
      "textContent": _vm._s(!_vm.discussItem.ipAddress && 'IP：未知' || 'IP：' + _vm.discussItem.ipAddress)
    }
  }) : _vm._e()]), _vm._v(" "), _c('commentOperation', {
    attrs: {
      "item": _vm.discussItem,
      "isDetail": _vm.limitImg
    },
    on: {
      "detailShowPopover": _vm.detailShowPopover
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.limitImg == 3 && _vm.discussItem._picsLength > 3 && !(_vm.discussItem.source == 1 && _vm.discussItem.aid > 0)) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussItem.discussID,
          topicItem: _vm.discussItem
        }
      }
    }
  }, [_c('div', {
    staticClass: "listContent_tip"
  }, [_c('div', {
    staticClass: "listContent_tip_inner"
  }, [_c('span', [_vm._v("更多精彩内容，看详情")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyAgIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTY3Ni41Nzk1NTYgNTExLjI2MDQ0NGwtMzkwLjI1Nzc3OC0zOTAuMjI5MzMzYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAxIDEgNDAuMjQ4ODg5LTQwLjIyMDQ0Mzk5TDczNi45MTAyMjE5OSA0OTEuMTUwMjIyYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAwIDEgMWUtOCA0MC4yMjA0NDVMMzI2LjU3MDY2NyA5NDEuNzEwMjIyMDFhMjguNDQ0NDQ0IDI4LjQ0NDQ0NCAwIDAgMS00MC4yMjA0NDUtNDAuMjIwNDQ0MDFMNjc2LjU3OTU1NiA1MTEuMjYwNDQ0eiIgIGZpbGw9IiM5OTk5OTkiPjwvcGF0aD48L3N2Zz4=",
      "alt": ""
    }
  })])])]) : _vm._e()], 1), _vm._v(" "), (_vm.limitImg === 9) ? _c('praiseDanner', {
    attrs: {
      "discussItem": _vm.discussItem
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44b0c872"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discussDetail/discussDetail.vue
// module id = 322
// module chunks = 1